import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useInfluencerAuth } from '../../contexts/InfluencerAuthContext';
import {
  Dashboard,
  Person,
  Menu,
  Close,
  Logout
} from '../../mui-icons';
import './InfluencerLayout.css';
import logoIcon from '../../assets/icon-no-name.webp';

const InfluencerLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { influencer, logout } = useInfluencerAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/influencer/login');
  };

  const menuItems = [
    {
      path: '/influencer',
      label: 'Dashboard',
      icon: <Dashboard />,
      exact: true
    },
    {
      path: '/influencer/profile',
      label: 'Meu Perfil',
      icon: <Person />
    }
  ];

  const isActive = (path, exact = false) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className="influencer-layout surface-app">
      {/* Mobile Overlay */}
      {mobileMenuOpen && (
        <div className="influencer-overlay" onClick={closeMobileMenu} />
      )}

      {/* Header */}
      <header className="influencer-header">
        <div className="header-left">
          <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
            {mobileMenuOpen ? <Close /> : <Menu />}
          </button>
          <Link to="/influencer" className="header-logo">
            <img src={logoIcon} alt="PersonalNutri" />
            <span>Portal do Influenciador</span>
          </Link>
        </div>

        <div className="header-right">
          <div className="user-info">
            <span className="user-name">{influencer?.name}</span>
          </div>
          <button className="logout-btn" onClick={handleLogout} title="Sair">
            <Logout />
          </button>
        </div>
      </header>

      {/* Navigation */}
      <nav className={`influencer-nav ${mobileMenuOpen ? 'open' : ''}`}>
        {menuItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-link ${isActive(item.path, item.exact) ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            {item.icon}
            <span>{item.label}</span>
          </Link>
        ))}
      </nav>

      {/* Main Content */}
      <main className="influencer-content surface-app">
        {children}
      </main>
    </div>
  );
};

export default InfluencerLayout;

